import { useDispatch, useSelector } from "react-redux";
import Wrapper from "../../pages/styles/UsersWrapper";
import { FaCalendarAlt, FaUserSlash, FaUser } from 'react-icons/fa';
import UsersInfo from "./UsersInfo";
import moment from "moment";
import { Link } from "react-router-dom";


const Users = (props) => {
    const { _id, name, group, educaton, email, role, createdAt, active } = props;
    
    const dispatch = useDispatch();
    const date = moment(createdAt).format('MMM DD YYYY');

    return (
        <Wrapper>
            <header>
                <div className="main-icon">{name.charAt(0)}</div>
                <div className="info">
                    <h5>{name}</h5>
                    <p>{email}</p>
                </div>
            </header>
            <div className="content">
                <div className="content-center">
                    <UsersInfo icon={ active ? <FaUser/> : <FaUserSlash/> } text={ active ? 'Active': 'Not Active'}/>
                    <UsersInfo icon={<FaCalendarAlt/>} text={date}/>
                </div>
                <footer>
                    <div className="actions">
                       <Link to={`/profile?userId=${_id}&name=${name}&group=${group}&education=${educaton}&email=${email}&role=${role}&createdAt=${createdAt}&active=${active}`} className="btn feature-btn" onClick={() => console.log("Features")}>
                            View Details
                       </Link>
                       <button className="btn delete-btn" onClick={() => console.log("View Dialog to confirm and then delete")}>
                            Delete
                       </button>
                    </div>
                </footer>
            </div>
        </Wrapper>
    )
}
 
export default Users;